<template>
    <TopNav></TopNav>
		<h1>Regl Calculator</h1>
		<fieldset>
      <legend>Regl Calculator</legend>
      <label for="regltarihi">Last Regl Date:</label> <input type="date" v-model="regl" id="regltarihi">
      <br>
      <label for="gun">Regl Perdiod:</label> <input type="number" v-model.number="gunValue" id="gun" min="0"> days.
      <br>
      Next Regl Date: <span class="blue">{{ sonrakitarih() }}</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'
import moment from 'moment'

export default {
  name: "Regl",
  data() {
    return {
      regl: new Date(),
      gunValue: 28
    }
  },
  components: {
    TopNav
  },
  methods: {
    sonrakitarih: function () {
      moment.locale('en')
      return moment(this.regl).add(this.gunValue, 'days').format("LL");
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 139px;
}

input[type=number] {
    width: 100px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
